"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRelationshipProperties = void 0;
const _1 = require(".");
const property_1 = require("./property");
const createRelationshipProperties = (table, role) => {
    const result = {};
    table.relationships
        .filter(relationship => relationship.mapping.length)
        .map(relationship => {
        const relName = relationship.rel_name;
        const mappingItem = relationship.mapping[0];
        const column = mappingItem.column;
        const refTable = mappingItem.remoteTable;
        const ref = `${role}_${_1.metadataName(refTable)}`;
        const type = property_1.propertyJsonType(column);
        if (relationship.mapping.length !== 1)
            throw Error('object relationship with multi-column keys are not supported');
        if (relationship.rel_type === 'object') {
            result[relName] = {
                type,
                ref
            };
        }
        else if (relationship.rel_type === 'array') {
            result[relName] = {
                type: 'array',
                ref,
                items: {
                    type
                }
            };
            result[`${relName}_aggregate`] = {
                type: 'object',
                properties: {
                    aggregate: {
                        type: 'object',
                        properties: {
                            max: {
                                type: 'object',
                                properties: { updated_at: { type: ['string', 'null'] } }
                            }
                        }
                    }
                }
            };
        }
    });
    return result;
};
exports.createRelationshipProperties = createRelationshipProperties;
//# sourceMappingURL=relationships.js.map